import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Spotlights from './Spotlights';
import UIList from 'UIComponents/list/UIList';
import UIExpandableText, {
//@ts-expect-error this is exported but its not declared in TS
EXPANDABLE_TEXT_HEIGHT_OFFSET } from 'UIComponents/text/UIExpandableText';
import { formatCount, getBenchmarkDifference, getBenchmarkKey, getBenchmarkStatsForType } from '../../utils';
import styled from 'styled-components';
import { CARD_SHADOW_COLOR } from 'HubStyleTokens/theme';
import { CARD_SHADOW_ALPHA, CARD_SHADOW_BLUR_RADIUS, CARD_SHADOW_OFFSET_Y } from 'HubStyleTokens/sizes';
import I18n from 'I18n';
import { FRAMEWORK_INSIGHT_CONTEXT } from '../../constant';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Benchmark({
  benchmarkStats,
  metadata,
  options = {}
}) {
  const difference = getBenchmarkDifference(benchmarkStats, metadata);
  const formattedDifference = formatCount(difference);
  const benchmarkKey = getBenchmarkKey(benchmarkStats, metadata);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    "data-test-id": `benchmark-${benchmarkStats.benchmarkType}`,
    message: `messaging-insights.insights.insight.benchmarks.${benchmarkStats.benchmarkType}.${benchmarkKey}`,
    options: Object.assign({
      difference: formattedDifference
    }, options)
  });
}
const CARD_SHADOW_ALPHA_MULTIPLIER = 2;
const SpotlightsWithDarkerShadow = styled(Spotlights).withConfig({
  displayName: "Insight__SpotlightsWithDarkerShadow",
  componentId: "dijwp4-0"
})(["box-shadow:0 ", " ", " 0 rgb( from ", " r g b / ", "% );"], CARD_SHADOW_OFFSET_Y, CARD_SHADOW_BLUR_RADIUS, CARD_SHADOW_COLOR, Number(CARD_SHADOW_ALPHA) * CARD_SHADOW_ALPHA_MULTIPLIER * 100);
const UIListWithNoBottomMargin = styled(UIList).withConfig({
  displayName: "Insight__UIListWithNoBottomMargin",
  componentId: "dijwp4-1"
})(["margin-bottom:0;"]);
function Insight({
  spotlight,
  insight,
  context
}) {
  const {
    metadata
  } = insight;
  const currentRate = metadata.metricRate;
  const expectedRate = metadata.comparisonContext.baselineRate;
  const hubspotBenchmarkStats = getBenchmarkStatsForType('GLOBAL', metadata);
  const industryBenchmarkStats = getBenchmarkStatsForType('INDUSTRY', metadata);
  const showGlobalBenchmarkDetails = context !== FRAMEWORK_INSIGHT_CONTEXT.GLOBAL_BENCHMARK_CONTEXT;
  const showIndustryBenchmarkDetails = context !== FRAMEWORK_INSIGHT_CONTEXT.INDUSTRY_BENCHMARK_CONTEXT && (industryBenchmarkStats === null || industryBenchmarkStats === void 0 ? void 0 : industryBenchmarkStats.industryName);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(SpotlightsWithDarkerShadow, {
      context: context,
      className: "m-top-3 m-bottom-2",
      compact: true,
      current: currentRate,
      expected: expectedRate,
      polarity: spotlight.sentiment === 'POSITIVE',
      insightType: spotlight.insightType
    }), (showGlobalBenchmarkDetails || showIndustryBenchmarkDetails) && /*#__PURE__*/_jsxs(UIExpandableText, {
      maxHeight: EXPANDABLE_TEXT_HEIGHT_OFFSET,
      buttonAlign: "left",
      expandButtonText: I18n.text('messaging-insights.insights.insight.benchmarks.button.show'),
      collapseButtonText: I18n.text('messaging-insights.insights.insight.benchmarks.button.hide'),
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "messaging-insights.insights.insight.benchmarks.preamble"
      }), /*#__PURE__*/_jsxs(UIListWithNoBottomMargin, {
        styled: true,
        children: [showGlobalBenchmarkDetails && /*#__PURE__*/_jsx(Benchmark, {
          benchmarkStats: hubspotBenchmarkStats,
          metadata: metadata
        }), showIndustryBenchmarkDetails && /*#__PURE__*/_jsx(Benchmark, {
          benchmarkStats: industryBenchmarkStats,
          metadata: metadata,
          options: {
            industryName: I18n.text(`industry.${industryBenchmarkStats.industryName}`)
          }
        })]
      })]
    })]
  }, insight.id);
}
export default Insight;